import { render, staticRenderFns } from "./wapHeader2.vue?vue&type=template&id=6d7bbc85&scoped=true&"
import script from "./wapHeader2.vue?vue&type=script&lang=js&"
export * from "./wapHeader2.vue?vue&type=script&lang=js&"
import style0 from "./wapHeader2.vue?vue&type=style&index=0&id=6d7bbc85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7bbc85",
  null
  
)

export default component.exports